module.exports = __webpack_public_path__ + "static/media/hydraulic-filter-mr-card-back.5f133a7b.jpeg";